import React from "react";
import { useTranslation } from "react-i18next";

const Thanks = ({ isSuccessful }) => {
    const { t } = useTranslation();

    return (
        <>
            {isSuccessful && (
                <div className="overlay">
                    <div className="overlay__background"/>
                    <div className="overlay__container">
                        <p>
                            {t("thanks1")}<br/>
                            {t("thanks2")} <a href={"tel:" + process.env.REACT_APP_PHONE_NUMBER}>{process.env.REACT_APP_PHONE_TEXT}</a><br/>
                            {t("thanks3")}<br/>
                            {t("thanks4")} {process.env.REACT_APP_WEBSITE}
                        </p>
                    </div>
                </div>

            )}
        </>
    );
};

export default Thanks;